import { render, staticRenderFns } from "./tax-category-list.vue?vue&type=template&id=1e21939f&scoped=true&"
import script from "./tax-category-list.vue?vue&type=script&lang=js&"
export * from "./tax-category-list.vue?vue&type=script&lang=js&"
import style0 from "./tax-category-list.vue?vue&type=style&index=0&id=1e21939f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e21939f",
  null
  
)

export default component.exports